import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
const IMAGE_PACKAGE_URI = 'image-package';
// because only when we create or update export config the image code field called `code` but in other cases called `image_code`
const prepareImagePackageConfigs = (imagePackageConfigs) => {
    return imagePackageConfigs.map(({ image_code, ...imagePackageConfig }) => ({
        ...imagePackageConfig,
        code: image_code
    }));
};
class ImagePackagesApi extends BaseHttp {
    constructor(config) {
        super(config);
    }
    getUserImagePackages() {
        return this.privateRequest('GET', IMAGE_PACKAGE_URI);
    }
    getParentImagePackages() {
        return this.privateRequest('GET', `${IMAGE_PACKAGE_URI}/parent`);
    }
    createCustomImagePackage({ imagePackageConfigs, parentId, odooProductId, parentOdooProductId, ...imagePackage }) {
        const data = imagePackage;
        data.imagePackageConfigs = prepareImagePackageConfigs(imagePackageConfigs);
        data.parent = parentId;
        return this.privateRequest('POST', IMAGE_PACKAGE_URI, data);
    }
    updateCustomImagePackage({ id, parentId, type, odooProductId, parentOdooProductId, imagePackageConfigs, ...imagePackage }) {
        const data = imagePackage;
        data.imagePackageConfigs = prepareImagePackageConfigs(imagePackageConfigs);
        data.parent = parentId;
        return this.privateRequest('PUT', `${IMAGE_PACKAGE_URI}/${id}`, data);
    }
    deleteCustomImagePackage({ id }) {
        return this.privateRequest('DELETE', `${IMAGE_PACKAGE_URI}/${id}`);
    }
}
export default new ImagePackagesApi({
    baseURL: config.profileAPI.url
});
